import React from 'react';
import { ReaderPathCheck } from './ReaderPathCheck';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
import { HelpCircle } from 'lucide-react';
export function InvisibleReaders() {
  const missingSignals = ['Who read it?', 'What landed?', 'What did they need?', 'What next step fit?'];
  return <section className="py-24 px-6 max-w-4xl mx-auto relative" data-id="element-222" data-mp="22md9e1pdz1hm">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-223" data-mp="27ky6vtd9772d">
        <PathThread data-id="element-224" data-mp="27msjmkedfsvd" />
      </div>

      <div className="text-center mb-20" data-id="element-225" data-mp="2cj9j2ar0ttnr">
        <Reveal data-id="element-226" data-mp="2ci7wb90n7iq7">
          <h2 className="text-3xl md:text-5xl font-serif text-navy mb-8 leading-tight" data-id="element-227" data-mp="2clvoo4ucpz3c">
            Most readers never tell you <br data-id="element-228" data-mp="2lkh43r4j0xzw" />
            <span className="italic text-seaglass" data-id="element-229" data-mp="2lkzb9isq8wml">when the book mattered</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-230" data-mp="m84y53a2gela">
          <div className="text-lg text-text-muted leading-relaxed max-w-2xl mx-auto space-y-6" data-id="element-231" data-mp="m8wjll9y8vxu">
            <p data-id="element-232" data-mp="r6yc0wt9m7lz">
              Someone can buy the book, underline the chapter that sounds
              exactly like their situation, send it to a colleague, bring it
              into a team meeting, and think, "I probably need help with this."
            </p>
            <p data-id="element-233" data-mp="1ymlxceknfewn">And still remain invisible to you.</p>
            <p className="font-medium text-navy text-xl" data-id="element-234" data-mp="1yl11mlmllpx7">
              Not because they did not care. <br className="hidden md:block" data-id="element-235" data-mp="1tpvh9r8ugjb8" />
              Because the book never gave them a useful reason to step forward.
            </p>
          </div>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-24" data-id="element-236" data-mp="2me1028gc7y8f">
        {missingSignals.map((signal, idx) => <Reveal key={idx} delay={0.1 * idx} data-id="element-237" data-mp="2hc1zf6bzfff6" data-mpi={idx}>
            <div className="bg-white border border-gray-100 rounded-2xl p-6 text-center shadow-[0_8px_20px_-12px_rgba(26,40,56,0.15)] hover:-translate-y-1 transition-transform duration-300 flex flex-col items-center justify-center min-h-[140px] gap-4 group" data-id="element-238" data-mp="2cesb5u0bx9sx">
              <div className="w-10 h-10 rounded-full bg-paper-dark flex items-center justify-center text-seaglass group-hover:bg-seaglass/10 transition-colors" data-id="element-239" data-mp="10y22834iu3vm">
                <HelpCircle className="w-5 h-5 opacity-50" data-id="element-240" data-mp="17fvcyh3g95eu" />
              </div>
              <span className="font-serif text-lg text-navy" data-id="element-241" data-mp="tg43mtnvod76">{signal}</span>
            </div>
          </Reveal>)}
      </div>

      <Reveal delay={0.2} data-id="element-242" data-mp="ydvy9vfwqdf2">
        <div id="quick-check-1" className="scroll-mt-32" data-id="element-243" data-mp="yd41wiehkbnq">
          <ReaderPathCheck questionId="q2.intent.handRaiserContext" checkLabel="Quick Check · 1 of 8" confirmationText="Saved. This helps check whether serious readers become visible after the book." data-id="element-244" data-mp="jpspyfee6pn3" />
          
        </div>
      </Reveal>
    </section>;
}